<template>
  <div>
    <el-tabs v-model="activeName" style="margin-top:20px;">
      <el-tab-pane v-for="item of tabLabel" :key="item.tabType" :label='item.label' :name="item.name">
        <HCLTable style="margin-top: 13px" :tableData="item.tableData" :tabType="item.tabType" :pagesize="pagesize" :loading="Loading"></HCLTable>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import auth from '@/auth/auth'
import HCLTable from './HCLTable.vue'
import exportToExcel from '@/lib/Export2Excel.js'
import { dailyData, accountData, groupData, invalidAccountData } from './dataStatisticsTaableHeader.json'
import publicMethod from './publicMethod'

export default {
  name: 'HCLStatistics',
  prop: {
    postData: Array,
  },
  components: {
    HCLTable
  },
  data () {
    return {
      groupMap: {},
      dailyDataMap: {},
      accountDataList: [],
      groupDataList: [],
      dailyDataList: [],
      accountInsulinDataMap: {},
      rangeList: {},
      outliers: {},
      Loading: false,
      activeName: 'group',
      pagesize: 10,
      invalidAccount: [],
      dataType: "HCL",
      allowType: ['BAS', 'BAE', 'BAH', 'BAPB', 'BAPA', 'BAPC', 'BAPD', 'BASK'],
      notAllowType: ['BAAMS', 'BAAME', 'BAAMBreakfast', 'BAAMLunch', 'BAAMDinner', 'BAAMSnack', 'BAAMExerciseStart', 'BAAMExerciseExit'],
      tabLabel: [],
      accountList: {},
      sel_time: new Date(2019, 0, 1).getTime(),
      BGAttribute: ['SGnum', 'TBRNum', 'TirNum', 'below30Num', 'beyond13Num', 'sumSG', 'tarNum'],
      AGPGraph: {
        'open': Array.from(new Array(144), () => { return new Array() }),
        'close': Array.from(new Array(144), () => { return new Array() })
      },
      AGPGraphList: {
        'open': {
          'T1Data': new Array(144),
          'Q1Data': new Array(144),
          'midData': new Array(144),
          'Q2Data': new Array(144),
          'T9Data': new Array(144),
        },
        'close': {
          'T1Data': new Array(144),
          'Q1Data': new Array(144),
          'midData': new Array(144),
          'Q2Data': new Array(144),
          'T9Data': new Array(144),
        }
      },
      TIRComparisonGraph: {
        'open': {},
        'close': {}
      },
      TIRComparisonList: {
        'Q1Data': new Array(),
        'midData': new Array(),
        'Q2Data': new Array(),
        'avgData': new Array(),
      },
      TBRComparisonGraph: {
        'open': {},
        'close': {}
      },
      TBRComparisonList: {
        'Q1Data': new Array(),
        'midData': new Array(),
        'Q2Data': new Array(),
        'avgData': new Array(),
      },
      TIRDistributionGraph: {
        'open': new Array(),
        'close': new Array()
      },
      TIRDistributionList: {
        'open': {
          nameList: new Array(),
          value: new Array()
        },
        'close': {
          nameList: new Array(),
          value: new Array()
        }
      },
      A1CDistributionGraph: {
        'open': new Array(),
        'close': new Array()
      },
      A1CDistributionList: {
        'open': {
          nameList: new Array(),
          value: new Array()
        },
        'close': {
          nameList: new Array(),
          value: new Array()
        }
      },
    }
  },
  methods: {
    exportExcel () {
      if (this.Loading) {
        this.$message.warning('数据量较大请等待加载完成')
      } else {
        const writeData = [
          {
            'tableType': groupData,
            'tableData': this.groupDataList,
            'sheetName': '汇总数据'
          },
          {
            'tableType': accountData,
            'tableData': this.accountDataList,
            'sheetName': '个人汇总数据'
          },
          {
            'tableType': dailyData,
            'tableData': this.dailyDataList,
            'sheetName': '个人每日数据',
            'needMarkOutliers': true
          },
          {
            'tableType': invalidAccountData,
            'tableData': this.invalidAccount,
            'sheetName': '无效账号'
          },
        ]
        if (this.groupDataList.length) {
          exportToExcel(writeData, 'HCLstatistics', this.outliers)
        }
      }
    },
    exportGraph () {
      if (this.Loading) {
        this.$message.warning('数据量较大请等待加载完成')
      } else {
        if (localStorage.getItem('HCLGraph')) {
          window.open('/#/HCLprint', '_black')
        }
      }
    },
    getSG (item, startTime, isOpen) {
      let [targetLow, targetHigh] = [3.9, 10]
      let daysumSG = 0, daySGnum = 0, daybelow30Num = 0, dayTBRNum = 0, dayTirNum = 0, daytarNum = 0, daybeyond13Num = 0
      if (item.length) {
        item.map(i => {
          if (i.length) {
            if (['C', 'CX', 'NC'].includes(i[4]) && i[3] && i[3] > 0.001) {
              if (i[3] < 2.2) {
                i[3] = 2.2
              } else if (i[3] > 22.2) {
                i[3] = 22.2
              }
              let SG = i[3]
              let count = Math.floor(parseInt(i[1] - startTime) / 600);
              if (count < 144 && count >= 0) {
                this.AGPGraph[isOpen][count].push(SG)
              }
              daySGnum += 1
              if (SG < 3.0) {
                daybelow30Num += 1
              }
              if (SG < targetLow) {
                dayTBRNum += 1
              } else if (SG <= targetHigh) {
                dayTirNum += 1
              } else {
                daytarNum += 1
              }
              if (SG > 13.9) {
                daybeyond13Num += 1
              }
              daysumSG += SG
            }
          }
        })
      }
      return { sumSG: daysumSG, SGnum: daySGnum, below30Num: daybelow30Num, TBRNum: dayTBRNum, TirNum: dayTirNum, tarNum: daytarNum, beyond13Num: daybeyond13Num }
    },
    getAutoMode (item) {
      let newUmax = 0, newIbasal = 0
      if (item[0] && item[0].length) {
        newUmax = Math.floor(item[0][2].newUmax * 100) / 100
        newIbasal = Math.floor(item[0][2].newIbasal * 100) / 100
      }
      return { umax: newUmax, newbasal: newIbasal }
    },
    getBasal (dayData, today) {
      let dayTime = 0, dayAutoTime = 0, dayBasal = 0, dayAutoBolus = 0
      const tomorrow = today + 86400
      if (dayData.length) {
        dayData.map((item, i) => {
          let basalType = item[2];
          let recordIdPart = item[0].split('-')[3];
          let tmpTime = item[3]
          if (item[1] < today) {
            tmpTime = item[3] + item[1] - today
          } else if (item[1] + item[3] > tomorrow) {
            tmpTime = tomorrow - item[1]
          }
          if ('9999' !== recordIdPart && '65535' !== recordIdPart) {
            if ('BAAM' === basalType) {
              dayAutoTime += tmpTime
              dayTime += tmpTime
              let autoModeData = item[7];
              if (autoModeData) {
                autoModeData = JSON.parse(autoModeData);
                let microBolusJson = autoModeData['autoModeJSON'];
                let cur_auto_basal_total = 0;
                let cur_auto_bolus_total = 0;

                microBolusJson.map(microBolusitem => {
                  cur_auto_basal_total += microBolusitem['auto_basal_delivery'];
                  cur_auto_bolus_total += microBolusitem['auto_food_delivery'] + microBolusitem['auto_corr_delivery'];
                })
                dayBasal += cur_auto_basal_total * 0.05;
                dayAutoBolus += cur_auto_bolus_total * 0.05;
              }
            } else if (!this.notAllowType.includes(basalType)) {
              dayBasal += item[5]
              dayTime += tmpTime
            }
          }
        })
      }
      return { totalTime: dayTime, autoTime: dayAutoTime, totalBasal: dayBasal, dayAutoBolus: dayAutoBolus }
    },
    getBolus (dayData) {
      let dayBolus = 0
      if (dayData.length) {
        dayData.map(item => {
          if (item[0].split('-')[3] < 8888) {
            dayBolus += (item[4] + item[6])
          }
        })
      }
      return { totalBolus: dayBolus }
    },
    getPercent (Numerator, denominator, flag) {
      let res = 0.00
      if (denominator) {
        res = Numerator / denominator
      }
      if (flag === 1) {
        return Math.round(res * 100) / 100
      }
      return Math.round(res * 1000) / 10 + '%'
    },
    calGroupAvg (numeratorList, denominatorList, needPercent = true) {
      let len = numeratorList.length
      let arr = numeratorList.map((numerator, index) => {
        if (numerator === 0 || denominatorList[index] === 0) {
          return 0
        }
        return numerator / denominatorList[index]
      })
      let avg = arr.reduce((sum, next) => sum + next) / len
      let SD = Math.sqrt(arr.map(item => Math.pow(item - avg, 2)).reduce((sum, next) => sum + next) / len)
      if (needPercent) {
        return Math.round(avg * 1000) / 10 + '% ± ' + Math.round(SD * 1000) / 10 + '%'
      } else {
        return Math.round(avg * 10) / 10 + ' ± ' + Math.round(SD * 10) / 10
      }
    },
    calculateData (rawData, isGroup = false) {
      let SGnum, avgSG, below30Percent, TBRPercent, TirPercent, tarPercent, beyond13Percent, AutoPercent, avgBasal, basalPercent, avgBolus, bolusPercent, TDDPercent, TDD
      let groupName = rawData.groupName
      if (!isGroup) {
        SGnum = rawData.SGnum
        if (rawData.SGnum) {
          avgSG = Math.round(rawData.sumSG / rawData.SGnum * 10) / 10
        } else {
          avgSG = 0.0
        }
        below30Percent = this.getPercent(rawData.below30Num, rawData.SGnum, 2)
        TBRPercent = this.getPercent(rawData.TBRNum, rawData.SGnum, 2)
        TirPercent = this.getPercent(rawData.TirNum, rawData.SGnum, 2)
        tarPercent = this.getPercent(rawData.tarNum, rawData.SGnum, 2)
        beyond13Percent = this.getPercent(rawData.beyond13Num, rawData.SGnum, 2)
      } else {
        SGnum = rawData.SGnum.reduce((sum, next) => sum + next)
        avgSG = this.calGroupAvg(rawData.sumSG, rawData.SGnum, false)
        below30Percent = this.calGroupAvg(rawData.below30Num, rawData.SGnum)
        TBRPercent = this.calGroupAvg(rawData.TBRNum, rawData.SGnum)
        TirPercent = this.calGroupAvg(rawData.TirNum, rawData.SGnum)
        tarPercent = this.calGroupAvg(rawData.tarNum, rawData.SGnum)
        beyond13Percent = this.calGroupAvg(rawData.beyond13Num, rawData.SGnum)
      }

      AutoPercent = this.getPercent(rawData.autoTime, rawData.totalTime, 2)
      avgBasal = this.getPercent(rawData.totalBasal, rawData.dayNum, 1)
      avgBolus = this.getPercent(rawData.totalBolus, rawData.dayNum, 1)
      TDD = avgBasal + avgBolus
      if (rawData.hasOwnProperty('avgTDD')) {
        TDDPercent = rawData.avgTDD ? this.getPercent(TDD, rawData.avgTDD, 2) : 'error0'
      }
      basalPercent = this.getPercent(avgBasal, TDD, 2)
      bolusPercent = this.getPercent(avgBolus, TDD, 2)
      return { groupName, SGnum, avgSG, below30Percent, TBRPercent, TirPercent, tarPercent, beyond13Percent, AutoPercent, avgBasal, basalPercent, avgBolus, bolusPercent, TDDPercent, TDD }
    },
    // 清空HCL相关数据
    resetHCL () {
      this.invalidAccount.length = 0
      this.accountDataList.length = 0
      this.groupDataList.length = 0
      this.dailyDataList.length = 0
      this.dailyDataMap = {}
      this.groupMap = {}
      this.TIRComparisonGraph = {
        'open': {},
        'close': {}
      }
      this.AGPGraph = {
        'open': Array.from(new Array(144), () => { return new Array() }),
        'close': Array.from(new Array(144), () => { return new Array() })
      }
      this.TBRComparisonGraph = {
        'open': {},
        'close': {}
      }
      this.TIRDistributionGraph = {
        'open': new Array(),
        'close': new Array()
      }
      this.A1CDistributionGraph = {
        'open': new Array(),
        'close': new Array()
      }

      this.AGPGraphList = {
        'open': {
          'T1Data': new Array(144),
          'Q1Data': new Array(144),
          'midData': new Array(144),
          'Q2Data': new Array(144),
          'T9Data': new Array(144),
        },
        'close': {
          'T1Data': new Array(144),
          'Q1Data': new Array(144),
          'midData': new Array(144),
          'Q2Data': new Array(144),
          'T9Data': new Array(144),
        }
      }
      this.TIRComparisonList = {
        'Q1Data': new Array(),
        'midData': new Array(),
        'Q2Data': new Array(),
        'avgData': new Array(),
      }
      this.TBRComparisonList = {
        'Q1Data': new Array(),
        'midData': new Array(),
        'Q2Data': new Array(),
        'avgData': new Array(),
      }
      this.TIRDistributionList = {
        'open': {
          nameList: new Array(),
          value: new Array()
        },
        'close': {
          nameList: new Array(),
          value: new Array()
        }
      }
      this.A1CDistributionList = {
        'open': {
          nameList: new Array(),
          value: new Array()
        },
        'close': {
          nameList: new Array(),
          value: new Array()
        }
      }
    },
    // 判断数据是否在限制范围内
    isInRange (num, [min, max]) {
      let realNum = 0
      if (typeof num === 'string') {
        // 处理百分比数据
        if (num.match(/%$/g)) {
          realNum = +num.replace('%', '') / 100
        } else {
          realNum = +num
          // 如果realNum是NaN, 不进行处理
          if (realNum !== realNum) {
            return false
          }
        }
      } else if (typeof num === 'number') {
        realNum = num
      } else {
        return false
      }
      if (realNum <= max && realNum >= min) {
        return true
      } else {
        return false
      }
    },
    // 判断某个属性值
    checkDate (date, [prop, propData], rangeList) {
      // 不判断error0数据
      if (propData === 'error0') {
        return false
      }
      // 同一日期、账户、开闭环之下可能有不同组的范围数据，按照写入顺序进行依次判断，取先命中日期的值
      const DATE = new Date(date) / 1000
      for (let item of rangeList) {
        if (item[prop] && Array.isArray(item[prop])) {
          if (this.isInRange(DATE, [new Date(item.startDate.split('GMT')[0]) / 1000, new Date(item.endDate.split('GMT')[0]) / 1000])) {
            return this.isInRange(propData, item[prop])
          } else {
            continue
          }
        } else {
          // 不是范围值就略过
          return true
        }
      }
      return true
    },
    calA1C (avgSG) {
      return Math.floor(((avgSG * 18) + 46.7) / 28.7 * 10);
    },
    getDistributionList (distributionGraph, distributionList, isA1C = false) {
      let tmpDistributionList = {
        'open': new Array(100).fill(0),
        'close': new Array(100).fill(0)
      }
      for (let [isopen, isopenData] of Object.entries(distributionGraph)) {
        let totalNum = isopenData.length
        isopenData.sort((x, y) => { return x[1] - y[1] })
        isopenData.map(item => {
          tmpDistributionList[isopen].push([item[1], 1])
          distributionList[isopen].nameList.push(item[0])
        })
        let preItem = 0
        tmpDistributionList[isopen].map(item => {
          if (item !== 0) {
            if (isA1C) {
              distributionList[isopen].value.push([item[0] / 10, Math.floor((preItem + item[1]) / totalNum * 100) / 100])
            } else {
              distributionList[isopen].value.push([item[0], Math.floor((preItem + item[1]) / totalNum * 100)])
            }
            preItem = item[1] + preItem
          }
        })
      }
    },
    insertData (isopenData, index, tmpComparisonList, baseLineDate, isTBR = false) {
      // 以4周为周期
      const duration = 28 * 86400000
      let dateList = Object.keys(isopenData).sort((x, y) => x - y)
      let endDate = new Date(baseLineDate).getTime() + duration
      tmpComparisonList[index] = tmpComparisonList[index] || []
      dateList.map(date => {
        if (index !== 0 && new Date(date).getTime() > endDate) {
          endDate = endDate + duration
          index += 1
          tmpComparisonList[index] = tmpComparisonList[index] || []
        }
        // 对TIR不统计为0的数据，对TBR不统计为-1的数据
        if (isTBR) {
          if (isopenData[date] >= 0 && isopenData[date] !== null) {
            tmpComparisonList[index].push(isopenData[date])
          }
        } else if (isopenData[date]) {
          tmpComparisonList[index].push(isopenData[date])
        }
      })
    },
    getComparisonList (comparisonGraph, comparisonList, isTBR = false) {
      let tmpComparisonList = []
      // 一定是先有开环数据再有闭环数据，遍历所有开环账户
      for (let [isopen, isopenData] of Object.entries(comparisonGraph)) {
        for (let [account, accountData] of Object.entries(isopenData)) {
          // 开环数据作为baseline，直接进行统计，闭环数据根据第一天按28天间隔进行划分
          if (isopen === 'open') {
            this.insertData(comparisonGraph['open'][account], 0, tmpComparisonList, '', isTBR)
          } else {
            // 按时间排序
            let dateList = Object.keys(accountData).sort((x, y) => x - y)
            const baseLineDate = dateList[0]
            // 前4周开环数据作为baseline
            this.insertData(comparisonGraph['close'][account], 1, tmpComparisonList, baseLineDate, isTBR)
          }
        }
      }
      // 统计作图用数据
      tmpComparisonList.map((item, index) => {
        let len = item.length
        if (len) {
          let offset = 0.75
          item.sort((x, y) => { return x - y })
          comparisonList.Q1Data[index] = [index + offset, item[Math.floor(0.25 * len)]]
          comparisonList.Q2Data[index] = [index + offset, item[Math.floor(0.75 * len)]]
          comparisonList.midData.push([index + offset, item[Math.floor(0.5 * len)]])
          comparisonList.midData.push([index + 0.5 + offset, item[Math.floor(0.5 * len)]])
          comparisonList.midData.push(null)
          comparisonList.avgData[index] = [index + 1, this.getAvg(item)]
        }
      })

    },
    getTime (index) {
      return this.sel_time + (index * 10 + 5) * 60000
    },
    getAvg (arr) {
      return Math.floor(arr.reduce((sum, data) => {
        return sum + data
      }) / arr.length * 100) / 100
    },
    getAGPGraphList () {
      for (let [isopen, isopenData] of Object.entries(this.AGPGraph)) {
        isopenData.map((item, index) => {
          let len = item.length;
          if (len) {
            item.sort((x, y) => { return x - y })
            let T1index = Math.floor(0.1 * len);
            let Q1index = Math.floor(0.25 * len);
            let midIndex = Math.floor(0.5 * len);
            let Q3index = Math.floor(0.75 * len);
            let T9index = Math.floor(0.9 * len);
            let tmpTime = this.getTime(index)
            this.AGPGraphList[isopen]['T1Data'][index] = [tmpTime, item[T1index]]
            this.AGPGraphList[isopen]['Q1Data'][index] = [tmpTime, item[Q1index]]
            this.AGPGraphList[isopen]['midData'][index] = [tmpTime, item[midIndex]]
            this.AGPGraphList[isopen]['Q2Data'][index] = [tmpTime, parseFloat((item[Q3index] - item[Q1index]).toFixed(1))]
            this.AGPGraphList[isopen]['T9Data'][index] = [tmpTime, parseFloat((item[T9index] - item[T1index]).toFixed(1))]
          }
        })
      }
    },
    calGraphData () {
      localStorage.removeItem('HCLGraph')
      this.getAGPGraphList()
      this.getComparisonList(this.TIRComparisonGraph, this.TIRComparisonList)
      this.getComparisonList(this.TBRComparisonGraph, this.TBRComparisonList, true)
      this.getDistributionList(this.TIRDistributionGraph, this.TIRDistributionList)
      this.getDistributionList(this.A1CDistributionGraph, this.A1CDistributionList, true)
      localStorage.setItem('HCLGraph', JSON.stringify({
        AGPGraphList: this.AGPGraphList,
        TIRComparisonList: this.TIRComparisonList,
        TBRComparisonList: this.TBRComparisonList,
        TIRDistributionList: this.TIRDistributionList,
        A1CDistributionList: this.A1CDistributionList
      }))
    },
    sendRequest (arr, max, callback, oneRequest) {
      let promiseList = [],  // 存储并发max的promise数组
        i = 0;
      const LENGTH = arr.length
      function toFetch () {
        if (i === LENGTH) {   // 所有的都处理完了， 返回一个resolve
          return Promise.resolve();
        }

        let one = oneRequest(arr[i++]); // 取出第i个url， 放入fetch里面 , 每取一次i++
        promiseList.push(one);  //将当前的promise存入并发数组中
        let oneRequestResult = true
        one.then(() => {
            promiseList.splice(promiseList.indexOf(one), 1)
            oneRequestResult = true
          }).catch((reject) => {
            if(reject === 'error'){
              oneRequestResult = false
            }
          })
        if(oneRequestResult){
            let p = Promise.resolve();
          if (promiseList.length >= max) {     // 当并行数量达到最大后， 用race比较 第一个完成的， 然后再调用一下函数自身。
            p = Promise.race(promiseList);
          }
          return p.then(() => toFetch());
        }else{
          return Promise.resolve()
        }
      }

      // arr循环完后， 现在fetchArr里面剩下最后max个promise对象， 使用all等待所有的都完成之后执行callback
      toFetch().then(() => Promise.all(promiseList)).then(() => {
        callback();
      })
    },
    afterRequest () {
      this.outliers['个人每日数据'] = []
      // 计算每日数据，同时进行TIR、TBR统计
      for ([groupindex, groupValue] of Object.entries(this.dailyDataMap)) {
        for ([account, accountValue] of Object.entries(groupValue)) {
          for ([dataSource, datasourceValue] of Object.entries(accountValue)) {
            for ([isOpen, isOpenValue] of Object.entries(datasourceValue)) {
              let unsortedData = []
              for ([date, dateValue] of Object.entries(isOpenValue)) {
                let dailyMap = { groupName: groupindex, date, account, userName: dateValue.userName, data_source: dataSource, isOpen: isOpen === 'open' ? '开环' : '闭环' }
                // 初始化异常数据相关变量
                let hasOutlier = false, tmpOutlier = { date, data_source: dataSource, account, isOpen: isOpen === 'open' ? '开环' : '闭环' }
                tmpOutlier.props = []
                // 计算每日数据指标
                publicMethod.addProps(dailyMap, this.calculateData(dateValue))
                dailyMap.umax = dateValue.umax
                dailyMap.newbasal = dateValue.newbasal
                // 异常值校验
                if (!this.isInRange(dailyMap.newbasal, [0.5 * (dailyMap.basal / 24), 2 * (dailyMap.basal / 24)])) {
                  tmpOutlier.props.push('newbasal')
                  hasOutlier = true
                }
                if (!this.isInRange(dailyMap.umax, [0.5 * dailyMap.newbasal, 5 * dailyMap.newbasal])) {
                  tmpOutlier.props.push('umax')
                  hasOutlier = true
                }
                for ([prop, propData] of Object.entries(dailyMap)) {
                  // 如果有异常数据
                  if (!this.checkDate(date, [prop, propData], this.rangeList[account][dataSource][isOpen])) {
                    tmpOutlier.props.push(prop)
                    hasOutlier = true
                  }
                }
                // 是异常值就放入异常值列表
                if (hasOutlier) {
                  this.outliers['个人每日数据'].push(tmpOutlier)
                }
                unsortedData.push(dailyMap)
              }
              unsortedData.sort((obj1, obj2) => { return new Date(obj1.date) - new Date(obj2.date) })
              this.dailyDataList.push(...unsortedData)
            }
          }
        }
      }
      // 计算分组数据
      for ([key, value] of Object.entries(this.groupMap)) {
        this.groupDataList.push(this.calculateData(value, true))
      }
      // 排序
      this.accountDataList.sort((obj1, obj2) => { return obj1.groupName.split('组')[1] - obj2.groupName.split('组')[1] })
      this.groupDataList.sort((obj1, obj2) => { return obj1.groupName.split('组')[1] - obj2.groupName.split('组')[1] })
      this.Loading = false
      publicMethod.invalidAccountMSG(this.invalidAccount, this)
      // 绘制图形
      this.calGraphData()
    },
    oneRequest (postDataitem) {
      const startDate = postDataitem.startDate
      const beforeStartDate = new Date(startDate) / 1000 - 86400 * 14
      const TS = auth.getTs(beforeStartDate, new Date(postDataitem.endDate) / 1000)
      // 学习值使用的是前一天的数据
      const autoModeTS = auth.getTs(new Date(startDate) / 1000 - 86400, new Date(postDataitem.endDate) / 1000)
      const accountName = postDataitem.account
      const userName = this.accountList[accountName].userName
      const dataSource = postDataitem.data_source === '实时' ? 'daopapp' : 'daoppdm'
      const isOpen = postDataitem.isOpen === '开环' ? 'open' : 'close'
      if (this.accountList[accountName].uid) {
        const param = {
          sg: { ts: TS },
          bolus: { ts: TS },
          basal: { ts: TS },
          data_source: dataSource,
          auto_mode: { ts: autoModeTS }
        };
        const groupName = postDataitem.group
        const targetTime = 23.5 * 3600

        this.dailyDataMap[groupName] = this.dailyDataMap[groupName] || {}
        this.dailyDataMap[groupName][accountName] = this.dailyDataMap[groupName][accountName] || {}
        this.dailyDataMap[groupName][accountName][dataSource] = this.dailyDataMap[groupName][accountName][dataSource] || {}
        this.dailyDataMap[groupName][accountName][dataSource][isOpen] = this.dailyDataMap[groupName][accountName][dataSource][isOpen] || {}
        this.TIRComparisonGraph[isOpen][accountName] = {}
        this.TBRComparisonGraph[isOpen][accountName] = {}
        let sumSG = 0, SGnum = 0, below30Num = 0, TBRNum = 0, TirNum = 0, tarNum = 0, beyond13Num = 0
        let totalTime = 0, autoTime = 0, totalBasal = 0, totalBolus = 0, avgTDD = 0, dayNum = 0, umax = 0, newbasal = 0
        let twoWeekRecords = new Array(), tdd = 0

        let promise = new Promise((resolve, reject) => {
          this.$http.post('/api/v2.1/data/' + this.accountList[accountName].uid, param).then(res => {
            if (res.status === 200) {
              if (res.body.error === 0) {
                // let targetHigh = res.data.data.target_high?res.data.data.target_high:10
                // let targetLow = res.data.data.target_low?res.data.data.target_low:3.9
                res.data.data.bolus.map((dayData, index) => {
                  let day = publicMethod.formatterDate(startDate, index - 14)
                  let tmpDayTime = beforeStartDate + 86400 * index
                  // 先判断是否有SG
                  let SGlength = res.data.data.sg[index].length
                  // 再处理basal数据，同时满足没有SG数据、闭环、非自动模式的数据，不统计运行时间
                  // 如果自动模式时间为0，不统计当天数据
                  let tmpDayData = this.getBasal(res.data.data.basal[index], tmpDayTime, isOpen === 'open', SGlength)
                  // 处理bolus数据
                  publicMethod.addProps(tmpDayData, this.getBolus(dayData, tmpDayData.autoTime || isOpen === 'open'))
                  // 在此处将每日自动模式bolus加入总bolus
                  tmpDayData.totalBolus += tmpDayData.dayAutoBolus

                  // 每日数据统计结束，下面进行汇总

                  tdd = 0
                  // 如果当天使用泵时间少于21 小时，不统计该天Basa、Bolus和TDD数据
                  // 闭环情况下，当自动模式时间为0，不进行统计
                  if (tmpDayData.totalTime > targetTime && (isOpen === 'open' || tmpDayData.autoTime)) {
                    tdd += tmpDayData.totalBasal
                    tdd += tmpDayData.totalBolus
                  }
                  if (index < 14) {
                    // 前14天只统计TDD
                    twoWeekRecords.push(tdd)
                  } else {
                    // 处理SG数据
                    publicMethod.addProps(tmpDayData, this.getSG(res.data.data.sg[index], tmpDayTime, isOpen))
                    publicMethod.addProps(tmpDayData, { dayNum: 1, userName: userName })
                    // 处理学习值数据
                    publicMethod.addProps(tmpDayData, this.getAutoMode(res.data.data.auto_mode[index - 14]))
                    // 汇总个人数据,进行数据筛选,个人每日数据不进行筛选
                    // 闭环、自动模式时间为0时，不统计当天SG
                    if (tmpDayData.autoTime || isOpen === 'open') {
                      SGnum += tmpDayData.SGnum
                      sumSG += tmpDayData.sumSG
                      below30Num += tmpDayData.below30Num
                      TBRNum += tmpDayData.TBRNum
                      TirNum += tmpDayData.TirNum
                      tarNum += tmpDayData.tarNum
                      beyond13Num += tmpDayData.beyond13Num
                    }

                    // 如果当天使用泵时间少于21 小时，不统计该天Basa、Bolus和TDD数据
                    if (tmpDayData.totalTime > targetTime) {
                      // 没有自动模式时间时，不统计时间
                      if (tmpDayData.autoTime) {
                        totalTime += tmpDayData.totalTime
                        autoTime += tmpDayData.autoTime
                      }
                      // 闭环情况下，当自动模式时间为0，不进行统计
                      if (isOpen === 'open' || tmpDayData.autoTime) {
                        totalBasal = publicMethod.addNumFixed(totalBasal, tmpDayData.totalBasal)
                        totalBolus = publicMethod.addNumFixed(totalBolus, tmpDayData.totalBolus)
                      }
                      dayNum += 1
                    }
                    // umax,newbasal为最后一天的值
                    umax = tmpDayData.umax
                    newbasal = tmpDayData.newbasal
                    let sumTDD = 0, TDDnum = 0
                    twoWeekRecords.map(i => {
                      if (i > 0) {
                        sumTDD += i
                        TDDnum += 1
                      }
                    })
                    avgTDD = this.getPercent(sumTDD, TDDnum, 1)
                    tmpDayData['avgTDD'] = avgTDD
                    this.dailyDataMap[groupName][accountName][dataSource][isOpen][day] = tmpDayData
                    // 不考虑数据来源，同一用户同一天只会产生一条数据
                    let TIRPercent = this.getPercent(tmpDayData.TirNum, tmpDayData.SGnum, 2)
                    // 用-1标记没有SGnum的数据
                    let TBRPercent = tmpDayData.SGnum ? this.getPercent(tmpDayData.TBRNum, tmpDayData.SGnum, 2) : -1
                    // 统计TIR, 0数据不统计
                    this.TIRComparisonGraph[isOpen][accountName][day] = parseFloat(TIRPercent)
                    // 统计TBR, 当天没有SG数据不进行统计
                    this.TBRComparisonGraph[isOpen][accountName][day] = parseFloat(TBRPercent)
                    twoWeekRecords.shift()
                    twoWeekRecords.push(tdd)
                  }
                })
                // 计算个人汇总数据
                let lineData = { dayNum, groupName, sumSG, SGnum, below30Num, TBRNum, TirNum, tarNum, beyond13Num, totalTime, autoTime, totalBasal, totalBolus }
                const accountData = this.calculateData(lineData)
                accountData.account = accountName
                accountData.userName = userName
                accountData.data_source = dataSource
                accountData.isOpen = postDataitem.isOpen
                accountData.umax = umax
                accountData.newbasal = newbasal
                this.accountDataList.push(accountData)
                // 统计TIR累积
                this.TIRDistributionGraph[isOpen].push([userName, parseFloat(accountData.TirPercent)])
                // 统计A1C累计
                this.A1CDistributionGraph[isOpen].push([userName, this.calA1C(accountData.avgSG)])

                if (this.groupMap[groupName]) {
                  for ([key, value] of Object.entries(lineData)) {
                    if (this.BGAttribute.find(x => x === key) !== undefined) {
                      this.groupMap[groupName][key] = this.groupMap[groupName][key] ? [...this.groupMap[groupName][key], value] : [this.groupMap[groupName][key]]
                    } else if (key !== 'groupName') {
                      this.groupMap[groupName][key] = this.groupMap[groupName][key] + value
                    }
                  }
                } else {
                  this.groupMap[groupName] = lineData
                  this.BGAttribute.map(key => {
                    this.groupMap[groupName][key] = [lineData[key]]
                  })
                }
                resolve('success')
              }
            } else {
              this.$message.warning("请求失败: ", this.accountList[accountName], ': ', { accountName, dataSource })
              this.Loading = false
              reject('error')
            }
          }).catch(e => {
            this.$message.warning("请求失败: ", this.accountList[accountName], ': ', { accountName, dataSource })
            this.Loading = false
            reject('error')
          })
        })
        return promise
      } else {
        this.invalidAccount.push({ accountName })
        return Promise.resolve()
      }
    },
    // 将文件数据上传到服务器端
    uploadToServer (postData) {
      this.accountList = {}
      this.rangeList = {}
      postData.map(item => {
        this.accountList[item.account] = {}
        this.rangeList[item.account] = this.rangeList[item.account] || {}
        // 由于同一用户同一数据来源可能在不同组，放到数组中，按照表格顺序，使用第一个匹配到的范围规则
        let dataSource = item.data_source === '实时' ? 'daopapp' : 'daoppdm'
        let isOpen = item.isOpen === '开环' ? 'open' : 'close'
        this.rangeList[item.account][dataSource] = this.rangeList[item.account][dataSource] || {}
        this.rangeList[item.account][dataSource][isOpen] = this.rangeList[item.account][dataSource][isOpen] ? [...this.rangeList[item.account][dataSource][isOpen], item] : [item]
      })
      const getUidData = {
        'username': Object.keys(this.accountList)
      }
      this.Loading = true
      this.$http.post('/api/v2.0/admin/user/get_uids', getUidData).then(res => {
        if (res.status === 200) {
          this.resetHCL()
          if (res.body.error === 0 && res.body.data.length !== 0) {
            res.body.data.map(item => {
              this.accountList[item[0]] = { uid: item[1], userName: item[2] }
            })
            this.sendRequest(postData, 3, this.afterRequest, this.oneRequest)
          } else {
            this.Loading = false
            postData.map(item => {
              this.invalidAccount.push({ accountName: item.account })
            })
            publicMethod.invalidAccountMSG(this.invalidAccount, this)
          }
        }else{
          this.Loading = false
          this.$message.warning('请求错误，网络异常')
        }
      }).catch(e => {
        this.Loading = false
        this.$message.warning('请求错误，网络异常')
        console.log({ e });
      })
    },
  },
  created () {
    this.tabLabel = [
      {
        'label': '汇总数据',
        'name': 'group',
        'tableData': this.groupDataList,
        'tabType': groupData
      },
      {
        'label': '个人汇总数据',
        'name': 'account',
        'tableData': this.accountDataList,
        'tabType': accountData
      },
      {
        'label': '个人每日数据',
        'name': 'daily',
        'tableData': this.dailyDataList,
        'tabType': dailyData
      },
    ]
  }
}
</script>
<style scoped>
>>> .el-table td > div {
  white-space: nowrap;
}
.graph {
  width: 800px;
  height: 500px;
}
</style>



// WEBPACK FOOTER //
// HCLStatistics.vue?1c300242